import { Instance, types } from 'mobx-state-tree';

const breakpoint = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: __IsMTSTipos__ ? 1280 : 1200,
    xxl: 1600,
    xxxl: __IsMTSTipos__ ? 1920 : 1900
};

export const ScreenInfoKey = 'screenInfo';

export const ScreenInfo = types
    .model(ScreenInfoKey, {
        screenWidth: types.optional(types.number, 0),
        //NOT USED NOW screenHeight: types.optional(types.number, 0)
        bodyWidth: types.optional(types.number, 0)
    })
    .views(self => ({
        get isXs(): boolean {
            return self.screenWidth <= breakpoint.sm;
        },
        get isSm(): boolean {
            return self.screenWidth > breakpoint.sm && self.screenWidth <= breakpoint.md;
        },
        get isMd(): boolean {
            return self.screenWidth > breakpoint.md && self.screenWidth <= breakpoint.lg;
        },
        get isLg(): boolean {
            return self.screenWidth > breakpoint.lg && self.screenWidth <= breakpoint.xl;
        },
        get isXl(): boolean {
            return self.screenWidth > breakpoint.xl && self.screenWidth <= breakpoint.xxl;
        },
        get isXxl(): boolean {
            return self.screenWidth > breakpoint.xxl && self.screenWidth <= breakpoint.xxxl;
        },
        get isXxxl(): boolean {
            return self.screenWidth > breakpoint.xxxl;
        },
        get isSmUp(): boolean {
            return self.screenWidth > breakpoint.sm;
        },
        get isMdUp(): boolean {
            return self.screenWidth > breakpoint.md;
        },
        get isLgUp(): boolean {
            return self.screenWidth > breakpoint.lg;
        },
        get isXlUp(): boolean {
            return self.screenWidth > breakpoint.xl;
        },
        get isXxlUp(): boolean {
            return self.screenWidth > breakpoint.xxl;
        },
        get isXxlDown(): boolean {
            return self.screenWidth < breakpoint.xxl;
        },
    }))
    .actions(self => {
        const resizeHandler = () => {
            self.screenWidth = window.innerWidth;
            self.bodyWidth = window.document.body.clientWidth;
        };

        const init = () => {
            resizeHandler();
        };

        return {
            init
        };
    });

export type IScreenInfo = Instance<typeof ScreenInfo>;
